import Sortable from "sortablejs";
import { C } from "../common/component";
import { Requester } from "../common/requester";
import { Icon, IconHelper } from "../common/icon-helper";
import { Dialog } from "../common/dialog";
import { MessageDisplayer } from "../common/message-displayer";
import { Txt } from "../common/text";
import { ButtonBuilder } from "../common/button-builder";
import { Dom } from "../common/dom";
import { Tooltip } from "../common/tooltip";

interface ViewSettingsPageDataUnit {
    Key: string;
    DisplayName: string;
    Tooltip: string;
}

interface ViewSettingsPageData {
    Buttons: ViewSettingsPageDataUnit[];
    DisplayedColumns: ViewSettingsPageDataUnit[];
    HiddenColumns: ViewSettingsPageDataUnit[];
}

export class ViewSettings
{
    static addSettingsButton(parent, icon: Icon, tooltip: string, onClick: () => void)
    {
        C.span.text(" ").appendTo(parent);
        const element = C.span.addClass("icon-cell small-icon").appendTo(parent);
        IconHelper.addIcon(element, icon);
        element.css("cursor", "pointer");
        Tooltip.attach(element[0], tooltip);
        element.click(onClick);
    }

    static async openSettingsModal(url: string, title: string, onChange: () => void)
    {
        const data: ViewSettingsPageData = await Requester.get(url);
        const modal = new Dialog(title);
        modal.show();

        const table = Dom.add("table", modal.body);
        table.style.tableLayout = "fixed";
        table.style.width = "100%";
        table.style.marginBottom = "20px";

        const tableHeader = Dom.add("thead", table);
        const displayedTitle = Dom.add("h4", Dom.add("th", tableHeader));
        displayedTitle.style.paddingLeft = "15px";
        displayedTitle.innerText = Txt.displayed;
        const hiddenTitle = Dom.add("h4", Dom.add("th", tableHeader));
        hiddenTitle.style.paddingLeft = "22px";
        hiddenTitle.innerText = Txt.hidden;

        const sortableContainer = Dom.add("tr", Dom.add("tbody", table));
        const displayedColumnsElement = Dom.add("td", sortableContainer, "w-displayed-columns");
        displayedColumnsElement.style.width = "50%";
        displayedColumnsElement.style.verticalAlign = "top";
        displayedColumnsElement.style.paddingRight = "7px";
        for (const column of data.DisplayedColumns)
        {
            this.createDraggableElement(column).appendTo(displayedColumnsElement);
        }
        const displayedSortable = Sortable.create(displayedColumnsElement, {
            group: "shared",
            animation: 150
        });

        const hiddenColumnsElement = Dom.add("td", sortableContainer, "w-hidden-columns");
        hiddenColumnsElement.style.width = "50%";
        hiddenColumnsElement.style.verticalAlign = "top";
        hiddenColumnsElement.style.paddingLeft = "7px";
        for (const column of data.HiddenColumns)
        {
            this.createDraggableElement(column).appendTo(hiddenColumnsElement);
        }
        const hiddenSortable = Sortable.create(hiddenColumnsElement, {
            group: "shared",
            animation: 150
        });

        for (const button of data.Buttons)
        {
            ButtonBuilder.get({
                name: button.DisplayName,
                cssClass: "main-button",
                onClick: async () =>
                {
                    const displayedColumns = JSON.stringify(displayedSortable.toArray({ attribute: "data-id" }));
                    const hiddenColumns = JSON.stringify(hiddenSortable.toArray({ attribute: "data-id" }));
                    try
                    {
                        await Requester.send(Requester.getUrl(button.Key, {
                            displayedColumns: displayedColumns,
                            hiddenColumns: hiddenColumns
                        }));
                    }
                    catch (err)
                    {
                        MessageDisplayer.showErrorFromServer(err);
                        return;
                    }
                    modal.hide();
                    onChange();
                }
            }).appendTo(modal.body);
        }
    }

    private static createDraggableElement(data: ViewSettingsPageDataUnit)
    {
        const element = C.div.addClass("list-group-item").attr("data-id", data.Key)
            .css("margin", "2px").css("cursor", "pointer")
            .text(data.DisplayName);
        if (data.Tooltip)
        {
            Tooltip.attach(element[0], data.Tooltip);
        }
        return element;
    }
}
